export enum BreathingStepType {
  step = "step",
}
